import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightBulkScheduleComponent } from './flight-bulk-schedule.component';
import { APP_ROUTES_MAIN } from './flight-bulk-schedule.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { SharedModule } from '../../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';

@NgModule({
  declarations: [
    FlightBulkScheduleComponent,
    CreateComponent,
    ListComponent
  ],
  imports: [
    APP_ROUTES_MAIN,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    DataTablesModule
  ]
})
export class FlightBulkScheduleModule { }
